module.exports = __webpack_public_path__ + "media/images/location-8ab7da6b.png";